import React, { useState } from 'react';
import styled from 'styled-components';
import { FaTwitter, FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo.png';

const GooglePlayIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path fill="#4CAF50" d="M491.4,244.2c-20.2-20.2-44.5-35.3-71.3-44.4L55.5,1.2C40-3.9,23.3,1.5,13.2,13.9c-9.9,12.2-9.9,28.9,0,41.1l111,136.2L124.2,321c-10.1,12.4-10.1,29.1,0,41.5c10.1,12.4,26.7,17.8,41.1,12.7l313.4-156.7C498.1,311.7,511.6,283.6,491.4,244.2z"/>
    <path fill="#FFC107" d="M13.2,498.1c-10.1-12.4-10.1-29.1,0-41.5L240.4,256L124.2,191.8L13.2,41.1C3.3,28.9,3.3,12.2,13.2,0c3.3,4.4,5.5,9.2,6.6,14.3l111,341.3L13.2,498.1z"/>
    <path fill="#F44336" d="M380.7,288.5L55.5,510.8c5,1.1,10.3,1.1,15.6,0l324-162c24.6-12.3,40-36.6,40-63.5c0-6.6-1.1-13.1-3.2-19.2L380.7,288.5z"/>
    <path fill="#2196F3" d="M380.7,223.5L325.2,256l55.5-22.3L491.8,170c-2.1-6.2-5.3-11.9-9.5-17.2L380.7,223.5z"/>
  </svg>
);

const FooterContainer = styled.footer`
  background: radial-gradient(circle at top, #020617, #020617 40%, #020617 80%);
  border-top: 1px solid #1e293b;
`;

const ContentWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: 2fr 1fr 1.3fr;
  }
`;

const InfoColumn = styled.div`
  @media (min-width: 768px) {
    padding-right: 2rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

const LogoImage = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  filter: drop-shadow(0 0 10px rgba(59, 130, 246, 0.4));
`;

const LogoText = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
  background: linear-gradient(to right, #22d3ee, #3b82f6, #8b5cff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Description = styled.p`
  color: #94a3b8;
  margin-bottom: 1rem;
  max-width: 30rem;
  font-size: 0.95rem;
`;

const Tagline = styled.p`
  color: #e5e7eb;
  font-size: 0.88rem;
  margin-bottom: 1.5rem;
  opacity: 0.9;
`;

const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const SocialLink = styled.a`
  color: #64748b;
  transition: color 0.25s ease, transform 0.2s ease;
  &:hover {
    color: #22d3ee;
    transform: translateY(-2px);
  }
`;

const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const PlayStoreButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background-color: #0f172a;
  border: 1px solid #334155;
  color: white;
  font-weight: 600;
  padding: 0.75rem 1.25rem;
  border-radius: 0.75rem;
  transition: background-color 0.25s ease, transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background-color: #1e293b;
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(15, 23, 42, 0.7);
  }
`;

const WebAppButton = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 0.75rem 1.4rem;
  border-radius: 0.75rem;
  font-weight: 600;
  text-decoration: none;
  font-size: 0.95rem;
  background: linear-gradient(135deg, #8b5cff, #6366f1);
  color: white;
  border: 1px solid rgba(129, 140, 248, 0.6);
  box-shadow: 0 12px 30px rgba(79, 70, 229, 0.6);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 40px rgba(79, 70, 229, 0.8);
  }
`;

const LinkColumn = styled.div``;

const ColumnTitle = styled.h4`
  color: white;
  font-weight: 600;
  margin-bottom: 1rem;
  font-size: 0.95rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

const FooterLink = styled(Link)`
  color: #94a3b8;
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.25s ease, transform 0.2s ease;
  &:hover {
    color: #22d3ee;
    transform: translateX(2px);
  }
`;

const ExternalFooterLink = styled.a`
  color: #94a3b8;
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.25s ease, transform 0.2s ease;
  &:hover {
    color: #22d3ee;
    transform: translateX(2px);
  }
`;

const ContactList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ContactInfo = styled.li`
  display: flex;
  align-items: center;
  color: #94a3b8;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
`;

const ContactEmail = styled.a`
  color: #94a3b8;
  text-decoration: none;
  margin-left: 0.5rem;
  transition: color 0.25s ease;
  &:hover {
    color: #22d3ee;
  }
`;

const TokenBlock = styled.li`
  color: #94a3b8;
  font-size: 0.875rem;
  margin-top: 1rem;
`;

const TokenLabel = styled.span`
  font-weight: 600;
  color: white;
`;

const TokenAddress = styled.span`
  font-size: 0.75rem;
  word-break: break-all;
  display: block;
  margin-top: 0.25rem;
`;

const CopyButton = styled.button`
  margin-top: 0.35rem;
  padding: 0.25rem 0.6rem;
  font-size: 0.7rem;
  border-radius: 999px;
  border: 1px solid #334155;
  background-color: #020617;
  color: #cbd5f5;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.1s ease;

  &:hover {
    background-color: #1e293b;
    color: #e5e7eb;
    transform: translateY(-1px);
  }
`;

const Copyright = styled.div`
  border-top: 1px solid #1e2b3b;
  padding-top: 1.75rem;
  text-align: center;
  color: #94a3b8;
  font-size: 0.85rem;
`;

const LegalLinks = styled.div`
  margin-top: 0.75rem;
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
`;

const LegalLink = styled(Link)`
  color: #94a3b8;
  font-size: 0.85rem;
  text-decoration: none;
  transition: color 0.25s ease;
  &:hover {
    color: var(--primary-color, #8b5cff);
  }
`;

export const Footer = () => {
  const [copied, setCopied] = useState(false);
  const tokenAddress = '0xdD3f2d1B0EC5ea81CDf70e79C713D35EF8d530E1';

  const handleCopy = () => {
    navigator.clipboard?.writeText(tokenAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <FooterContainer>
      <ContentWrapper>
        <Grid>
          {/* LEFT: BRAND + CTA */}
          <InfoColumn>
            <LogoContainer>
              <LogoImage src={logoImage} alt="Trend Genie Logo" />
              <LogoText>Trend Genie</LogoText>
            </LogoContainer>

            <Description>
              AI-powered market analysis, DeFi safety checks, and token utilities –
              all in one ecosystem designed for real traders, students, and builders.
            </Description>
            <Tagline>
              Scan charts. Scan contracts. Manage risk before you press buy.
            </Tagline>

            <SocialLinks>
              <SocialLink
                href="https://x.com/trendgenie_ai"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Trend Genie on X"
              >
                <FaTwitter size={20} />
              </SocialLink>
              <SocialLink
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Trend Genie GitHub"
              >
                <FaGithub size={20} />
              </SocialLink>
              <SocialLink
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Trend Genie LinkedIn"
              >
                <FaLinkedin size={20} />
              </SocialLink>
            </SocialLinks>

            <ButtonRow>
              <PlayStoreButton
                href="https://play.google.com/store/apps/details?id=com.entiresolutions.trendgenie"
                target="_blank"
                rel="noopener noreferrer"
              >
                <GooglePlayIcon style={{ width: '1.75rem', height: '1.75rem' }} />
                <div>
                  <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>GET IT ON</span>
                  <span style={{ display: 'block', fontSize: '1.125rem', marginTop: '-0.25rem' }}>
                    Google Play
                  </span>
                </div>
              </PlayStoreButton>

              <WebAppButton
                href="https://app.trendgenie.io"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Web App
              </WebAppButton>
            </ButtonRow>
          </InfoColumn>

          {/* MIDDLE: SITE LINKS */}
          <LinkColumn>
            <ColumnTitle>Explore</ColumnTitle>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li><FooterLink to="/">Home</FooterLink></li>
              <li><FooterLink to="/about">About</FooterLink></li>
              <li><FooterLink to="/pricing">Pricing</FooterLink></li>
              <li><FooterLink to="/rewards">Rewards</FooterLink></li>
              <li><FooterLink to="/live-results">Live Results</FooterLink></li>
              <li><FooterLink to="/insights">Insights</FooterLink></li>
              <li><FooterLink to="/whitepaper">Whitepaper</FooterLink></li>
            </ul>
          </LinkColumn>

          {/* RIGHT: WEB3 + CONTACT */}
          <LinkColumn>
            <ColumnTitle>Web3 & Tools</ColumnTitle>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li>
                <ExternalFooterLink
                  href="https://app.trendgenie.io"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  RugShield Scanner
                </ExternalFooterLink>
              </li>
              <li>
                <FooterLink to="/whitepaper">
                  $TGEN Utility Token
                </FooterLink>
              </li>
              <li>
                <FooterLink to="/whitepaper">
                  Ecosystem & Roadmap
                </FooterLink>
              </li>
            </ul>

            <ColumnTitle style={{ marginTop: '1.5rem' }}>Contact</ColumnTitle>
            <ContactList>
              <ContactInfo>
                <FaEnvelope style={{ marginRight: '0.5rem' }} />
                <ContactEmail href="mailto:contact@trendgenie.io">
                  contact@trendgenie.io
                </ContactEmail>
              </ContactInfo>
              <ContactInfo>
                <FaEnvelope style={{ marginRight: '0.5rem' }} />
                <ContactEmail href="mailto:support@trendgenie.io">
                  support@trendgenie.io
                </ContactEmail>
              </ContactInfo>

              <TokenBlock>
                <TokenLabel>Token Contract:</TokenLabel>
                <TokenAddress>{tokenAddress}</TokenAddress>
                <CopyButton type="button" onClick={handleCopy}>
                  {copied ? 'Copied!' : 'Copy address'}
                </CopyButton>
              </TokenBlock>
            </ContactList>
          </LinkColumn>
        </Grid>

        <Copyright>
          <p>&copy; {new Date().getFullYear()} Trend Genie. All rights reserved.</p>
          <LegalLinks>
            <LegalLink to="/privacy-policy">Privacy Policy</LegalLink>
          </LegalLinks>
        </Copyright>
      </ContentWrapper>
    </FooterContainer>
  );
};
